import { render, staticRenderFns } from "./Bridge.vue?vue&type=template&id=82a6c510"
import script from "./Bridge.vue?vue&type=script&lang=js"
export * from "./Bridge.vue?vue&type=script&lang=js"
import style0 from "./Bridge.vue?vue&type=style&index=0&id=82a6c510&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports